module.exports = __webpack_public_path__ + "static/img/message .37f7bc50.png";